var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-background-root",style:(_vm.rootStyle)},[_c('div',{class:{ 'main-preview-background default': true, 'full-body': _vm.isFullBodyCategory },style:({
      opacity: !_vm.currentBackgroundId ? _vm.backgroundOpacity : '0',
    })}),_vm._l((_vm.selectedBrands()),function(brand){return _c('div',{key:("fashion-background-" + (brand.id)),class:{ 'main-preview-background': true, 'full-body': _vm.isFullBodyCategory },style:({
      backgroundImage: ("url(" + (brand.store_background) + ")"),
      opacity:
        brand.id === _vm.currentBackgroundId && _vm.currentBackgroundType === _vm.BackgroundTypeEnum.OUTFIT
          ? _vm.backgroundOpacity
          : '0',
    })})}),_vm._l((_vm.selectedVoltronBrands()),function(brand){return _c('div',{key:("garment-background-" + (brand.id)),class:{ 'main-preview-background': true, 'full-body': _vm.isFullBodyCategory },style:({
      backgroundImage: ("url(" + (brand.store_background) + ")"),
      opacity:
        brand.id === _vm.currentBackgroundId &&
        _vm.currentBackgroundType === _vm.BackgroundTypeEnum.MIX_AND_MATCH
          ? '1'
          : '0',
    })})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }